// prompts.<area>.<key>: the suggested questions (services/platform-agent/platformAgentSuggestions.js), sent as typed.
// {{dish}} is a dish on the restaurant's menu, {{amount}} an amount in its currency (both from the picker).
export default {
  title: 'Olá {{first_name}}, de que precisa para {{restaurant}}?',
  title_no_name: 'Olá, do que precisa para {{restaurant}}?',
  text: 'Posso responder a perguntas sobre {{restaurant}} e fazer alterações por si. Nada muda sem a sua aprovação.',
  suggestions: 'Sugestões',
  prompts: {
    reports: {
      top_dishes: 'Quais foram os 10 pratos mais vendidos no mês passado?',
      sales_vs_last_month: 'Como evoluíram as vendas face ao mês passado?',
    },
    menu: {
      raise_dish_price: 'Aumentar o preço de {{dish}} em {{amount}}',
      dish_sold_out: 'Marcar {{dish}} como esgotado',
      dishes_without_photo: 'Que pratos não têm foto?',
    },
    hours: {
      holiday_hours: 'Alterar o nosso horário de funcionamento para 24 de dezembro',
    },
    order_settings: {
      minimum_order: 'Aumentar o pedido mínimo para {{amount}}',
    },
    marketing: {
      promo_code: 'Criar um código promocional de 10 % para este fim de semana',
    },
    my_info: {
      phone_number: 'Atualizar o nosso número de telefone',
    },
  },
};
